<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('gameSetResult.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('gameSetResult.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-end">
            <a-date-picker
              v-model="dateFilter"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              @change="onDateChange"   
            />
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.game_setting_name }}</td>
          <td>{{ record.draw_time }}</td>
          <td>
           {{ record.input_counter }}
          </td>
          <td>
           {{ record.result_number }}
          </td>
          <td class="ts-space-x-3 ts-whitespace-no-wrap ts-text-right">
            <a
              v-if="!record.is_current_user_input"
              href="#"
              v-tooltip="$t('gameSetResult.add')"
              class="text-primary"
              @click.prevent="addNew(record)"
            >
             <i class="far fa-plus-square"></i>
            </a>
            <a
              v-if="record.is_current_user_input"
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              v-if="record.is_current_user_input"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i
                  class="fas fa-circle-notch spin"
                  v-if="record.game_set_id == deleting_id"
                ></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </td>
        </template>
      </ts-table>
    </ts-card>
    <!-- show form create -->
    <a-modal
      v-if="show_form_create"
      v-model="show_form_create"
      :title="$t('gameSetResult.inputResult')"
      centered
      :footer="null"
      :zIndex="1020"
      :mask-closable="false"
      width="500px"
      @cancel="fetchData"
    >
      <form-create :gameinput="game_input" @close="onClose" />
    </a-modal>
    <!-- show form update -->
    <a-modal
      v-if="show_form_update"
      v-model="show_form_update"
      :title="$t('update')"
      centered
      :footer="null"
      :zIndex="1020"
      :mask-closable="false"
      width="500px"
      @cancel="onClose"
    >
      <form-update :gameinput="game_input" @close="onClose" />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import FormCreate from './components/frm_create'
import FormUpdate from './components/frm_update'
import moment from 'moment'

export default {
  name: 'gameSetResult',
  components: {
    FormCreate,
    FormUpdate
  },
  data() {
    return {
      visible: false,
      loading: false,
      show_form_create: false,
      show_form_update: false,
      game_input: {},
      deleting_id: null
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administrator/gameSetResult', ['resources']),
    dateFilter: {
      get() {
        return this.$store.state.administrator.gameSetResult.date_filter
      },
      set(newValue) {
        this.$store.commit('administrator/gameSetResult/SET_FILTER_DATE', newValue)
      }
    },
    search: {
      get() {
        return this.$store.state.administrator.gameSetResult.search
      },
      set(newValue) {
        this.$store.commit('administrator/gameSetResult/SET_SEARCH', newValue)
        this.$store.commit('administrator/gameSetResult/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('gameSetResult.gameSet') },
        { name: this.$t('gameSetResult.drawTime') },
        { name: this.$t('gameSetResult.inputCounter') },
        { name: this.$t('gameSetResult.resultNumber') },
        { name: this.$t('actions'), style: 'text-align:right; width:10px' }
      ]
    },
  },
  methods: {
    addNew(record) {
      this.show_form_create = true
      this.game_input = record
    },
    onClose() {
      this.show_form_update = false
      this.show_form_create = false
      this.game_input = {} 
      this.$store.commit('administrator/gameSetResult/SET_EDIT_DATA', {})
      this.fetchData()
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administrator/gameSetResult/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      // this.$store.commit('administrator/gameSetResult/SET_EDIT_DATA', record)
      this.game_input = record
      this.show_form_update = true
    },
    deleteRecord(record) {
      this.deleting_id = record.game_set_id
      this.$store
        .dispatch('administrator/gameSetResult/destroy', record.result_temp_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.deleting_id = null
        })
    },
    onDateChange(){
      this.fetchData() 
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('administrator/gameSetResult/RESET_STATE')
    next()
  }
}
</script>
